export default __webpack_public_path__ + "static/media/plain-sticker-K.d9378e75.png";